"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProviderKey;

(function (ProviderKey) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ProviderKey["MPI"] = "MPI"; // eslint-disable-next-line @typescript-eslint/naming-convention

  ProviderKey["DXM"] = "DXM";
})(ProviderKey = exports.ProviderKey || (exports.ProviderKey = {}));